import Swiper, { Autoplay } from 'swiper'
import 'swiper/css'
import 'swiper/css/autoplay'

export class CourseInstaSlider {
  constructor() {
    if (document.getElementById('sb_instagram') === null) return
    const sb_instagram = document.getElementById('sb_instagram')
    const sbi_images = document.getElementById('sbi_images')
    sb_instagram.classList.add('swiper')
    sbi_images.classList.add('swiper-wrapper')
    const instaSlider02 = new Swiper('#sb_instagram', {
      modules: [Autoplay],
      slidesPerView: 2,
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      slideClass: 'sbi_item',
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        767: {
          slidesPerView: 2.95,
        },
      },
    })

    if (document.getElementById('js-course_instagram') === null) return
    const instaSlider = new Swiper('#js-course_instagram', {
      modules: [Autoplay],
      slidesPerView: 2,
      spaceBetween: 10,
      loop: true,
      speed: 10000,
      allowTouchMove: false,
      autoplay: {
        delay: 0,
      },
      breakpoints: {
        767: {
          slidesPerView: 2.95,
          spaceBetween: 20,
        },
      },
    })
  }
}
